export default __webpack_public_path__ + "fb2422277de621a3f36450284284c765.png";